import api from "./api";

export const getContainers = (params = {}) => api.get("/containers", { params });
export const getContainer = (id) => api.get(`/containers/${id}`);
export const createContainer = (payload) => api.post("/containers", payload);
export const updateContainer = (id, payload) => api.put(`/containers/${id}`, payload);
export const deleteContainer = (id) => api.delete(`/containers/${id}`);

export const getAssignableCustomers = () =>
  api.get("/containers/customers/assignable");

export const bulkAssignContainersToCustomer = (payload) =>
  api.patch("/containers/bulk-assign-customer", payload);

export const getContainerDocuments = (containerId) =>
  api.get(`/containers/${containerId}/documents`);

export const uploadContainerDocuments = (containerId, formData) =>
  api.post(`/containers/${containerId}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteContainerDocument = (containerId, documentId) =>
  api.delete(`/containers/${containerId}/documents/${documentId}`);

export const downloadContainerDocument = async (containerId, document) => {
  const response = await api.get(
    `/containers/${containerId}/documents/${document.id}/download`,
    { responseType: "blob" }
  );

  const url = window.URL.createObjectURL(response.data);
  const anchor = window.document.createElement("a");
  anchor.href = url;
  anchor.download = document.originalName || "container-document";
  window.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

export const getAssignableCollaborators = () =>
  api.get("/containers/collaborators/assignable");

export const getContainerCollaborators = (containerId) =>
  api.get(`/containers/${containerId}/collaborators`);

export const replaceContainerCollaborators = (containerId, collaborators) =>
  api.put(`/containers/${containerId}/collaborators`, { collaborators });
